import React from 'react';
import { withRouter } from 'react-router-dom';
import Builder from './Builder';
import FormContent from '../FormContent';
import { FileSelection } from '../../containers/Files'
import NavigationTabs from '../nav/NavigationTabs'
import NavigationBlocker from './../navigationBlocker'
import { VALIDATION_MESSAGES } from '../../static-content';
import { AlertJsMessage } from './../../helpers.js';

class Form extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      expand: 1,
      submitAction: 'create',
      sequence: {},
      dataLoaded: false,
      edit: null,
      showPricingInput: false,
      selectedPricingType: "0",
      formData: {
        name: '',
        description: '',
        level: '',
        price: '',
        categoryId: '',
        storeId: '',
        isFeatured: false,
      },
      isValidating: false,
      isFormDataChange: false,
      isExerciseDataChange: false,
      sequenceData: {
      }
    };
  }

  

  
  componentDidMount() {
    this.props.fetch(this.props.user._id || localStorage.id, this.props.editId).then(() => {
      const { editId, workouts, workoutInfo } = this.props;
      if (Object.keys(workoutInfo).length > 0) {
        const editWorkout = workoutInfo;
        this.setState({
          ...this.state,
          selectedPricingType: editWorkout.price ? "1" : "0",
          showPricingInput: editWorkout.price,
          submitAction: 'edit',
          editWorkout: editWorkout,
          formData: {
            name: editWorkout.name,
            description: editWorkout.description,
            level: editWorkout.level,
            price: editWorkout.price,
            categoryId: editWorkout.categoryId,
            storeId: editWorkout.storeId,
            isFeatured: editWorkout.isFeatured,
            youtubeLink: editWorkout.youtubeLink && editWorkout.shortsUrl ?  editWorkout.shortsUrl : editWorkout.youtubeLink
          },
          dataLoaded: true,

        })
      } else {
        this.setState({
          ...this.state,
          submitAction: 'create',
          dataLoaded: true
        })
      }
    });
  }

  
  componentDidUpdate(prevProps) {
    if (prevProps.editId !== this.props.editId) {
      this.props.fetch(this.props.user._id || localStorage.id, this.props.editId).then(() => {
        const { editId, workouts, workoutInfo } = this.props;
        const editWorkout = workoutInfo;
        this.setState({
          ...this.state,
          selectedPricingType: editWorkout.price ? "1" : "0",
          showPricingInput: editWorkout.price,
          submitAction: 'edit',
          editWorkout: editWorkout,
          formData: {
            name: editWorkout.name,
            description: editWorkout.description,
            level: editWorkout.level,
            price: editWorkout.price,
            categoryId: editWorkout.categoryId,
            storeId: editWorkout.storeId,
            isFeatured: editWorkout.isFeatured
          },
          dataLoaded: true,

        })
      });

    }
  }

  handleExpand(step) {
    if (this.state.expand !== 0) {
      this.setState(state => ({ expand: state.expand === 1 ? 2 : 1 }));
    } else {
      this.setState({ expand: step });
    }
  }

  onCancel = () => {
    if (this.props.editId) {
      this.setState({ expand: 0 });
      return;
    } else {
      this.setState({
        expand: 0,
        formData: {
          name: '',
          description: '',
          level: '',
          price: '0',
          storeId: '',
          categoryId: '',
          youtubeLink: '',
          isFeatured: false
        }
      });
      return;
    }
  }

  handleChange = field => event => {
    if (field === 'price') {
      const price = event.target.value.replace(/[^0-9.]/g, "");
      this.setState({
        formData: {
          ...this.state.formData,
          price
        }
      })
    } else {
      if (field === 'isFeatured') {
        this.setState({
          formData: {
            ...this.state.formData,
            [field]: event.target.checked
          }
          })
      } else {
        this.setState({
        formData: {
          ...this.state.formData,
          [field]: event.target.value
        }
        })
      }
    }
    this.setState({
      isFormDataChange: true
    })
  }
  handlePriceRadio = field => event => {
    if (event.target.value === '1') {
      this.setState({
        ...this.state,
        showPricingInput: true,
        selectedPricingType: '1',
      })
    } else if (!event.target.value) {
      this.setState({
        ...this.state,
        showPricingInput: true,
        selectedPricingType: '',
      })
    } else {
      this.setState({
        ...this.state,
        formData: {
          ...this.state.formData,
          price: 0,
          storeId: ''
        },
        showPricingInput: false,
        selectedPricingType: "0"
      })
    }
  }
  matchYoutubeUrl(url) {
		const p = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
		if(url.match(p)){
			return url.match(p)[1];
		}
		return false;
	};
  validateForm() {
    const { selected } = this.builder.state;
    const { formData, showPricingInput } = this.state;
    // validate step 1 form data
    const required = [
      'name',
      'level',
      'categoryId'
    ];
    showPricingInput && required.push('price');
    for (var i = 0; i < required.length; i++) {
      if (!formData[required[i]]) {
        AlertJsMessage(VALIDATION_MESSAGES['WORKOUT'][required[i]]);
        return;
      }
    }
    //validate circuits are not empty.
    for (let i = 0; i < selected.length; i++) {
      let item = selected[i];
      if (item.type === 'circuit' && item.child) {
        const nextItem = selected[i + 1];
        if (nextItem.type === 'circuit' && nextItem.parent === item.id) {
          // Circuit contains no exercises
          AlertJsMessage(`Circuit must contain at least one exercise. Please add an exercise before continuing.`);
          return;
        }
      }
    }
    if(formData.youtubeLink && !this.matchYoutubeUrl(formData.youtubeLink)) {
			AlertJsMessage('Please enter valid youtube link.');
			return;
		}


    if(formData.youtubeLink) {
      const youtubeLink = formData.youtubeLink;
      if(youtubeLink.includes('shorts')) {
        const p = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
        formData.youtubeLink = `https://youtu.be/${youtubeLink.match(p)[1]}`
        formData.shortsUrl = youtubeLink;
      }
    } else {
      formData.shortsUrl = '';
    }

    
    // validate at least one exercise is selected.
    if (!selected.length || !selected.filter(x => !x.deleted).length) {
      AlertJsMessage('Please add an exercise before continuing.');
      return;
    }

    const { type, selectedFile, previewVideoSrc, previewImageSrc } = this.fileSelect.state;
    if (type === 'library') {
      if (selectedFile) {
        this.submitValidatedForm(formData, selected, selectedFile);
      } else {
        this.submitValidatedForm(formData, selected, null);
      }
    } else if (type === 'upload') {
      if (previewVideoSrc || previewImageSrc) {
        this.setState({
          ...this.state,
          isValidating: true
        }, () => {
          this.fileSelect.submitNewFile().then((file) => {
            this.submitValidatedForm(formData, selected, file);
          })
        })

      } else {
        this.submitValidatedForm(formData, selected, null);
      }
    } else {
      this.submitValidatedForm(formData, selected, null);
    }

  }

  submitValidatedForm(formData, selected, file) {
    const { history, editId } = this.props;
    if (file !== null) {
      formData.fileId = file._id;
      const fileType = file.fileType.toLowerCase();
      
      if (fileType === 'mp4' || fileType === 'mov') {
        formData.videoUrl = file.url;
        formData.imgUrl = file.url;
      } else {
        formData.imgUrl = file.url;
      }
    }
     if (this.state.submitAction === 'create') {
      this.props.create('workout', formData, selected).then((res) => {
        const _id = res.data.id;
        this.props.updateDuration(_id, 'ByWorkout').then(() => {
          this.setState({
            isFormDataChange:  false,
            isExerciseDataChange: false
          }, () => {
            window.location.href = '/preview/workouts/' + _id + "?new=true";
          });
        });
      });
    }
    if (this.state.submitAction === 'edit') {
      this.props.edit('workout', { ...formData, id: editId }, selected).then((res) => {
        this.props.updateDuration(editId, 'ByWorkout').then(() => {
          this.setState({
            isFormDataChange:  false,
            isExerciseDataChange: false
          }, () => {
            window.location.href = '/preview/workouts/' + editId + "?new=true";
          });
        });
      });
    }
  }

  handlePrice = () => (event) => {
    const { value } = event.target;
    const { price } = Object.values(this.props.products).find(x => x.storeId === value);
    this.setState(state => ({
      formData: {
        ...state.formData,
        storeId: value,
        price
      }
    }))
  }

  componentWillUnmount() {
    this.setState({
      isFormDataChange:  false,
      isExerciseDataChange: false
    });
    this.props.resetExercises();
    this.props.resetExerciseFilter();
    this.props.resetBlocks();
  }

  saveExerciseDataChange = (status) => {
    this.setState({
      isExerciseDataChange:  status
    });
  }

  
  render() {
    const { formData, dataLoaded, selectedPricingType, showPricingInput, submitAction, editWorkout, expand, isExerciseDataChange, isFormDataChange } = this.state;
    const { workoutCats, trainerExercises, favExercises, corporateExercises, equipment, exerciseCats, blockCats, editId, user, products, searchTerm } = this.props;
    return (
      <div>
        <NavigationBlocker isDataChanged={(isFormDataChange  || isExerciseDataChange)}></NavigationBlocker>
        {
          this.props.hideNavigationTabs ? null : (
            <NavigationTabs
              title="Build"
              subtitle="Workouts"
              description="Create workouts to assign to clients, partners, or to place in programs."
              set="build"
              activeRoute="/build/workout" />
          )
        }
        {dataLoaded &&
          <FormContent
            nameType="Workout"
            editId={editId}
            formData={formData}
            expand={expand}
            products={products}
            expansionChange={(step) => this.handleExpand(step)}
            formChange={(field) => this.handleChange(field)}
            priceSelectionChange={() => this.handlePriceRadio()}
            selectedPricingType={selectedPricingType}
            showPricingInput={showPricingInput}
            submitAction={submitAction}
            workoutCats={workoutCats}
            isValidating={this.state.isValidating}
            validateForm={() => this.validateForm()}
            onCancel={this.onCancel}
            priceRange={() => this.handlePrice()}
            FileSelection={(
              <FileSelection
                userData={user}
                fileType="mixed"
                category="WORKOUT_IMAGE"
                isShowHelpIcon={true}
                isSelectFromLibrary={true}
                selectedFileId={editWorkout ? editWorkout.fileId : 0}
                ref={(ref) => { this.fileSelect = ref ? ref.getWrappedInstance() : null }}
                showHelp
              />
            )}
            Builder={(
              <Builder
                editWorkout={editWorkout}
                ref={(ref) => { this.builder = ref }}
                trainerExercises={trainerExercises}
                corporateExercises={corporateExercises}
                favExercises = {favExercises}
                equipment={equipment}
                categories={exerciseCats}
                blockCats={blockCats}
                sequence={this.state.sequence}
                workoutFormData={this.state.formData}
                blocks={this.props.blocks}
                validateForm={() => this.validateForm()}
                isValidating={this.state.isValidating}
                onCancel={this.onCancel}
                user={user}
                fetchMoreExercise = {this.props.fetchMoreExercise}
                fetchMoreBlock = {this.props.fetchMoreBlock}
                resetExercises = {this.props.resetExercises}
                resetBlocks = {this.props.resetExercises}
                resetExerciseFilter = {this.props.resetExerciseFilter}
                exerciseStoreFilter = {this.props.filter}
                setExerciseFilter = {this.props.setExerciseFilter}
                setExerciseSearchTerm = {this.props.setExerciseSearchTerm}
                isLoadMoreLibraryExercises = {this.props.isLoadMoreLibraryExercises}
                isLoadMoreLibraryBlocks = {this.props.isLoadMoreLibraryBlocks}
                searchTerm = {this.props.searchTerm}
                toggleExerciseFavourite = {this.props.toggleExerciseFavourite}
                saveExerciseStatus = {this.saveExerciseDataChange}
              />
            )}
          />
        }
      </div>
    );
  }
}
export default withRouter(Form);



// WEBPACK FOOTER //
// ./src/components/workouts/Form.js